export { default as Homepage } from "./Homepage.svelte";
export { default as Test } from "./Test.svelte";
export { default as TestQuestionList } from "./TextQuestionList.svelte";
const list = {
    Homepage: () => import("./Homepage.svelte"),
    Test: () => import("./Test.svelte"),
    TextQuestionList: () => import("./TextQuestionList.svelte"),
};
export { list as default };
